import { PropsWithChildren, useRef, ReactNode, useEffect } from "react";
import { Flex, Box, FlexProps, Portal } from "@chakra-ui/react";
import { Sidebar } from "../layout/Sidebar";
import { AlertContext, useAlertRef } from "../../../components/alerts/AlertContext";
import { useGrowthBook } from "@growthbook/growthbook-react";
import { useUser } from "v2/modules/auth";

export function PageShell({
  children,
  sidebarContent = null,
  ...props
}: FlexProps & { sidebarContent?: ReactNode }) {
  const alertRef = useRef(null);
  const { profile } = useUser();
  const growthbook = useGrowthBook();

  useEffect(() => {
    growthbook.setAttributes({
      ...growthbook.getAttributes(),
      user_id: profile?.userProfileUuid,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile]);

  return (
    <Flex minHeight={"100vh"}>
      <AlertContext.Provider value={{ ref: alertRef }}>
        <Sidebar content={sidebarContent} />
        <Flex direction={"column"} flex={5} {...props}>
          <Box data-testid="alert-portal" ref={alertRef} />
          {children}
        </Flex>
      </AlertContext.Provider>
    </Flex>
  );
}

export function PageAlertPortal({ children }: PropsWithChildren) {
  const alertRef = useAlertRef();
  return <Portal containerRef={alertRef}>{children}</Portal>;
}
